import React from 'react';

const Blog = () => {
    return (
        <div>
            <h2 className="flex justify-center items-center text-5xl h-screen">COMING SOON...</h2>
            
        </div>
    );
};

export default Blog;